import { getDefaultSearchSourceCookie } from '#pplx/frontend/apps/ask/browser-state/cookieManager.js';
/**
 * Checks if part of Firefox default search session
 * First check cookie (persisted according to query param)
 * If no cookie, check query param directly (cookie may not be set in time)
 */
export const isFirefoxDefaultSearch = () => {
    const defaultSearchSource = getDefaultSearchSourceCookie();
    if (defaultSearchSource === 'firefox') {
        return true;
    }
    if (typeof window === 'undefined') {
        return false;
    }
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;
    const defaultSearchSourceParam = searchParams.get('pc');
    return defaultSearchSourceParam === 'firefox';
};
//# sourceMappingURL=firefoxUtils.js.map